import { Box, CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack5";
import React, { useRef, useState } from "react";

const useLoadingSnackbar = () => {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const loadRef = useRef(null);
  const showLoadSnackbar = (message = "Loading...") => {
    if (loadRef.current) return;
    setLoading(true);
    loadRef.current = enqueueSnackbar(
      <Box display="flex" alignItems="center" gap={1}>
        <CircularProgress size={20} color="inherit" />
        {message}
      </Box>,
      {
        persist: true,
      },
    );
  };
  const closeLoading = () => {
    if (loadRef?.current) {
      closeSnackbar(loadRef.current);
      loadRef.current = null;
      setLoading(false);
    }
  };
  return { showLoadSnackbar, closeLoading, loading };
  // useEffect(() => {
  //   let key = () => {};
  //   if (isLoading) {
  //     key = enqueueSnackbar(
  //       <Box display="flex" alignItems="center" gap={1}>
  //         <CircularProgress size={20} color="inherit" />
  //         Loading please wait...
  //       </Box>,
  //       {
  //         persist: true,
  //       },
  //     );
  //   } else {
  //     closeSnackbar(key);
  //   }
  // }, [isLoading]);
};

export default useLoadingSnackbar;
